import React from 'react'
import {Promotion} from '../../../types/singleModelInterface'
import formatCurrency from '../../../utils/currency/formatCurrency'

export type PromotionPriceData = Pick<
    Promotion,
    'price' | 'price_prefix' | 'price_suffix'
>

export const hasPromotionPrice = ({
    price,
    price_prefix,
    price_suffix,
}: PromotionPriceData): boolean =>
    Boolean(price_prefix || price_suffix || price)

/**
 * Price of a promotion as written in the CMS: prefix, amount and suffix. For
 * financing promotions the suffix carries TAN, TAEG, duration, down payment
 * and final instalment, so it is the copy to show wherever the offer is cited.
 */
export default function PromotionPrice({
    price,
    price_prefix,
    price_suffix,
}: PromotionPriceData): React.JSX.Element {
    return (
        <>
            {price_prefix ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: `${price_prefix}&nbsp;`,
                    }}
                />
            ) : undefined}
            {price ? (
                <span
                    style={{fontWeight: 'bold'}}
                    dangerouslySetInnerHTML={{
                        __html: formatCurrency(price),
                    }}
                />
            ) : undefined}
            {price_suffix ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: `&nbsp;${price_suffix}`,
                    }}
                />
            ) : undefined}
        </>
    )
}
